import { Button} from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Message from "../message";
import { useState } from "react";



const JobsScraper = () => {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;
  
  const [jobs_url, setJobs_url] = useState("")
  const [jobs_no_of_pages, setJobs_no_of_pages] = useState("")
  const [status_jobs, setStatus_jobs] = useState("");


  const submit_jobs = async () => {
    setStatus_jobs("");

    if (jobs_url === '' || jobs_no_of_pages === "") {
      setStatus_jobs("Fill all the fields!");
    } else {

      const requestOptions = {
        method: 'POST'
      };

      try {
        setStatus_jobs("Please wait...")
        const jobs_response = await fetch(
          apiServer + `api/jobs_scraper/scrape_jobs?no_of_pages=${Number(jobs_no_of_pages)}&request_url=${encodeURIComponent(jobs_url)}`, requestOptions
        );
        const jobs_status_id = await jobs_response.json();
        const jobs_status = jobs_status_id.detail ? jobs_status_id.detail : jobs_status_id
        
        setStatus_jobs(jobs_status)

      } catch (e) {
        console.log(e);
      }
    }
  };



  return (
    <div style={{ marginTop: "20px" }}>

      <TextField
        style={{ width: "100%" }}
        value={jobs_url}
        onChange={(e) => setJobs_url(e.target.value)}
        id="outlined-basic"
        label="Jobs Website URL"
        variant="filled"
      />
      <TextField
        style={{ marginTop: "2px", marginBottom: "15px", width: "100%" }}
        value={jobs_no_of_pages}
        onChange={(e) => setJobs_no_of_pages(e.target.value)}
        id="outlined-basic"
        label="No of pages"
        variant="filled"
      />

      <Button
        variant="primary"
        style={{ marginTop: "10px", width: "100%" }}
        onClick={() => submit_jobs()}
      >
        Submit
      </Button>
      {Message(status_jobs, setStatus_jobs)}
    </div>
  );
};

export default JobsScraper;
